/**
 * ## dashboard edit controller
 *
 * @module src/controller/dashedit
 */

"use strict";

const header = (textvalue, speed, height) => {
  $("#dashboard_header").css("display", "block");
  $("#dashboard_header").html(textvalue);
  if (window.self !== window.top) {
    $("#dashboard_header").append(`<div id='dashboard_header_popout'>\
        <a href='${window.location.href}' target='_blank'>Launch In New Tab</a></div>`);
  }
  TweenMax.to("#dashboard_header", speed, { height, ease: Power2.easeOut });
};

module.exports = {
  header,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/dashedit/index.js
 **/